import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';
import { ref, get } from 'firebase/database';

/**
 * FlowBuilderRouter
 * Fetches bot metadata AND flow data in parallel, then navigates with both
 * pre-loaded so the builder doesn't need a second Firebase round trip.
 */
export default function FlowBuilderRouter() {
  const { botId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!botId) { navigate('/dashboard'); return; }

    const resolve = async () => {
      const user = auth.currentUser;
      if (!user) { navigate('/login'); return; }

      try {
        // Fetch bot config and flow data in parallel — cuts load time in half
        const [botSnap, flowSnap] = await Promise.all([
          get(ref(db, `bots/${botId}`)),
          get(ref(db, `flows/${botId}`)),
        ]);
        if (!botSnap.exists()) { setError('Bot not found.'); return; }

        const bot = botSnap.val();
        const type: string = bot.botType || 'whatsapp';
        const preloadedFlow = flowSnap.exists() ? flowSnap.val() : null;

        const state = { preloadedFlow };

        switch (type) {
          case 'whatsapp':
            navigate(`/builder/whatsapp/${botId}`, { replace: true, state });
            break;
          case 'facebook':
            navigate(`/builder/facebook/${botId}`, { replace: true, state });
            break;
          case 'website':
            navigate(`/builder/website/${botId}`, { replace: true, state });
            break;
          case 'voice':
            navigate(`/builder/voice/${botId}`, { replace: true, state });
            break;
          default:
            navigate(`/builder/whatsapp/${botId}`, { replace: true, state });
        }
      } catch (e) {
        setError('Error loading bot.');
        console.error(e);
      }
    };

    resolve();
  }, [botId, navigate]);

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--bg-page)', fontFamily: 'system-ui' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚠️</div>
          <div style={{ color: 'var(--text-primary)', fontSize: '16px', marginBottom: '12px' }}>{error}</div>
          <button onClick={() => navigate('/dashboard')} style={{ background: '#5B4FE8', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}>
            Back to dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--bg-page)', fontFamily: 'system-ui' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</div>
        <div style={{ color: 'var(--text-muted)', fontSize: '14px' }}>Loading builder...</div>
      </div>
    </div>
  );
}
